import { useLocation, Navigate, Outlet } from "react-router-dom";


const RequireAuth = ({ allowedRoles }) => {
    const auth = localStorage.getItem("token");
    const location = useLocation();

    return (
        auth ? 
        <Outlet /> :
         <Navigate to="/" state={{ from: location }} replace />
    );
}

export default RequireAuth;